import { EventsV3 } from "@circle-react/components/EventsV3";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";

interface CreateEventModalProps {
  spaceId?: number | null;
}

const CreateEventModalComponent = ({ spaceId }: CreateEventModalProps) => {
  const { visible: isVisible, hide } = useModal();

  return (
    <EventsV3
      isOpen={isVisible}
      onClose={hide}
      spaceId={spaceId}
      shouldClearEventStateOnHide
    />
  );
};

export const CreateEventModal = ModalManager.create(
  ({ spaceId }: CreateEventModalProps) => (
    <CreateEventModalComponent spaceId={spaceId} />
  ),
);

export const useCreateEventModal = () => useModal(CreateEventModal);
